import { render, staticRenderFns } from "./SLAEventItem.vue?vue&type=template&id=e837816c&"
import script from "./SLAEventItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./SLAEventItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e837816c')) {
      api.createRecord('e837816c', component.options)
    } else {
      api.reload('e837816c', component.options)
    }
    module.hot.accept("./SLAEventItem.vue?vue&type=template&id=e837816c&", function () {
      api.rerender('e837816c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/components/SLAEventItem.vue"
export default component.exports